export default "assets/images/feuille_2-f6f31084.png";